import React from 'react';
import { AuthQcReportModal } from '@/types/modal';
import { useTranslation } from 'react-i18next';
import { NoFooterModal } from '@/components/molecules/common/Modal';
import { VcAuthQcReport } from '@vestiaire/vc-remote-components';
import { BootService } from '@/services/boot';

const AuthQcReport: React.FC<{ modal: AuthQcReportModal }> = ({ modal }) => {
  const { t } = useTranslation();

  const { productId, agentRole, onClose } = modal;

  return (
    <NoFooterModal
      title={t('item.compliance.qc_report.title')}
      onClose={onClose}
      body={
        <VcAuthQcReport
          isInternal
          agentRole={agentRole}
          productId={productId.toString()}
          config={{ env: BootService.env }}
        />
      }
      modalName="authQcReport"
    />
  );
};

export default AuthQcReport;
